export default {
  methods: {
    scrollTopSafety() {
      this.$nextTick(() => {
        if (this.$route.name === 'home') window.scrollTo({ top: 0, behavior: 'smooth' })
      })
    },
  },
}
